// eslint-disable-next-line import/no-cycle
import { checkTokenExpiry } from './checkTokenExpiry';

interface GetJsonProps {
  url: string;
  token?: string;
  raw?: boolean;
}

interface PostJsonProps {
  url: string;
  body?: TypeAny;
  token?: string;
  raw?: boolean;
  extraHeaders?: Record<string, TypeAny>;
}

export async function deleteJson({ url, token, raw = false }: GetJsonProps) {
  const isExpired = await checkTokenExpiry(token);
  const authHeader = token && {
    Authorization: `Bearer ${token}`
  };

  if (isExpired && token) {
    return { isExpired };
  }

  return fetch(url, {
    method: 'DELETE',
    headers:
      raw && !token
        ? undefined
        : {
            'Content-Type': 'application/json',
            ...authHeader
          }
  }).then(async (response) => {
    const jsonResponse = await response.json();
    return jsonResponse;
  });
}

export async function getJson({ url, token, raw = false }: GetJsonProps) {
  const isExpired = await checkTokenExpiry(token);
  const authHeader = token && {
    Authorization: `Bearer ${token}`
  };

  if (isExpired && token) {
    return { isExpired };
  }

  return fetch(url, {
    method: 'GET',
    headers:
      raw && !token
        ? undefined
        : {
            'Content-Type': 'application/json',
            ...authHeader
          }
  }).then(async (response) => {
    const jsonResponse = await response.json();
    return jsonResponse;
  });
}

export async function patchJson({ url, body, token, raw = false }: PostJsonProps) {
  const isExpired = await checkTokenExpiry(token);
  const authHeader = token && {
    Authorization: `Bearer ${token}`
  };

  if (isExpired && token) {
    return { isExpired };
  }

  return fetch(url, {
    method: 'PATCH',
    body: raw ? body : JSON.stringify(body),
    headers:
      raw && !token
        ? undefined
        : {
            'Content-Type': 'application/json',
            ...authHeader
          }
  }).then(async (response) => {
    const jsonResponse = await response.json();
    return jsonResponse;
  });
}

export async function postJson({
  url,
  body = {},
  token,
  raw = false,
  extraHeaders = {}
}: PostJsonProps) {
  const isExpired = await checkTokenExpiry(token);
  const authHeader = token && {
    Authorization: `Bearer ${token}`
  };

  if (isExpired && token) {
    return { isExpired };
  }

  const postHeaders =
    raw && !token
      ? undefined
      : {
          'Content-Type': 'application/json',
          ...authHeader
        };

  return fetch(url, {
    method: 'POST',
    body: raw ? body : JSON.stringify(body),
    headers: {
      ...postHeaders,
      ...extraHeaders
    }
  }).then(async (response) => {
    const jsonResponse = await response.json();
    return jsonResponse;
  });
}

export async function putJson({ url, body, token, raw = false }: PostJsonProps) {
  const isExpired = await checkTokenExpiry(token);
  const authHeader = token && {
    Authorization: `Bearer ${token}`
  };

  if (isExpired && token) {
    return { isExpired };
  }

  return fetch(url, {
    method: 'PUT',
    body: raw ? body : JSON.stringify(body),
    headers:
      raw && !token
        ? undefined
        : {
            'Content-Type': 'application/json',
            ...authHeader
          }
  }).then(async (response) => {
    const jsonResponse = await response.json();
    return jsonResponse;
  });
}
